export default "__VITE_ASSET__E8Dzu3OL__"